import {
  REMOVE_LISTS,
  SOURCE_QUALITY_EVALUATION_DASHBOARD_LOCATION,
  SOURCE_QUALITY_EVALUATION_DASHBOARD_RAW_MATERIAL,
  SOURCE_QUALITY_EVALUATION_DASHBOARD_TABLE_LOG,
} from './actions'

const initialState = {
  // *load ข้อมูลต้นแหล่ง
  source_list: [],
  check_source_list: false,

  // *load ข้อมูลวัตถุดิบ
  material_list: [],
  check_material_list: false,

  // *table log ประเมินคุณภาพ
  check_log_list: false,
  log_list: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return initialState

    case SOURCE_QUALITY_EVALUATION_DASHBOARD_LOCATION.REQUEST:
      return {
        ...state,
        source_list: [],
        check_source_list: true,
      }
    case SOURCE_QUALITY_EVALUATION_DASHBOARD_LOCATION.SUCCESS:
      return {
        ...state,
        source_list: action.payload.lists.origin_location || [],
        check_source_list: false,
      }

    case SOURCE_QUALITY_EVALUATION_DASHBOARD_RAW_MATERIAL.REQUEST:
      return {
        ...state,
        material_list: [],
        check_material_list: true,
      }
    case SOURCE_QUALITY_EVALUATION_DASHBOARD_RAW_MATERIAL.SUCCESS:
      return {
        ...state,
        material_list: action.payload.lists.data || [],
        check_material_list: false,
      }

    case SOURCE_QUALITY_EVALUATION_DASHBOARD_TABLE_LOG.REQUEST:
      return {
        ...state,
        check_log_list: true,
        log_list: [],
      }
    case SOURCE_QUALITY_EVALUATION_DASHBOARD_TABLE_LOG.SUCCESS:
      return {
        ...state,
        check_log_list: false,
        log_list: action.payload.lists.data || [],
      }

    default:
      return state
  }
}
